import { Action } from '@ngrx/store';

export const CREATE_SESSION = '[Session] Create Session...';
export const DELETE_SESSION = '[Session] Delete session...';

export class CreateSession implements Action {
    readonly type = CREATE_SESSION;
    constructor ( public payload: { fullname: string, email: string,username: string, roles: [], id: number } ) {
            }
}

export class DeleteSession implements Action {
    readonly type = DELETE_SESSION;
}

export type sessionActions = DeleteSession | CreateSession;
